export const regions = {
  전체: '',
  강원: 'GW',
  경기: 'GG',
  경남: 'GN',
  경북: 'GB',
  광주: 'GJ',
  대구: 'DG',
  대전: 'DJ',
  부산: 'BS',
  세종: 'SJ',
  울산: 'US',
  인천: 'IC',
  전남: 'JN',
  전북: 'JB',
  제주: 'JJ',
  충남: 'CN',
  충북: 'CB'
};

export const realSurveyRegions = {
  전체: 'ALL',
  강원: 'GW',
  '경기 고양': 'GY',
  '경기 안양': 'AY',
  '경기 용인': 'YI',
  경기: 'GG',
  서울: 'SU',
  경남: 'GN',
  경북: 'GB',
  광주: 'GJ',
  대구: 'DG',
  대전: 'DJ',
  부산: 'BS',
  세종: 'SJ',
  울산: 'US',
  인천: 'IC',
  전남: 'JN',
  전북: 'JB',
  제주: 'JJ',
  충남: 'CN',
  충북: 'CB'
};

export const localList = [
  { name: '전체', code: '' },
  { name: '강원', code: 'GW' },
  { name: '경기', code: 'GG' },
  { name: '경남', code: 'GN' },
  { name: '경북', code: 'GB' },
  { name: '광주', code: 'GJ' },
  { name: '대구', code: 'DG' },
  { name: '대전', code: 'DJ' },
  { name: '부산', code: 'BS' },
  { name: '세종', code: 'SJ' },
  { name: '울산', code: 'US' },
  { name: '인천', code: 'IC' },
  { name: '전남', code: 'JN' },
  { name: '전북', code: 'JB' },
  { name: '제주', code: 'JJ' },
  { name: '충남', code: 'CN' },
  { name: '충북', code: 'CB' }
];

export const realSurveyLocalList = [
  { name: '전체', code: 'ALL' },
  { name: '강원', code: 'GW' },
  { name: '경기 고양', code: 'GY' },
  { name: '경기 안양', code: 'AY' },
  { name: '경기 용인', code: 'YI' },
  { name: '경기', code: 'GG' },
  { name: '경남', code: 'GN' },
  { name: '경북', code: 'GB' },
  { name: '광주', code: 'GJ' },
  { name: '대구', code: 'DG' },
  { name: '대전', code: 'DJ' },
  { name: '부산', code: 'BS' },
  { name: '서울', code: 'SU' },
  { name: '세종', code: 'SJ' },
  { name: '울산', code: 'US' },
  { name: '인천', code: 'IC' },
  { name: '전남', code: 'JN' },
  { name: '전북', code: 'JB' },
  { name: '제주', code: 'JJ' },
  { name: '충남', code: 'CN' },
  { name: '충북', code: 'CB' }
];
